import { customRouter } from '@/customRouter'
import { getUserToken, removeUserToken, saveUserToken } from '@/services/tokenService'
import { apiRequest, mvcRequest } from '@/config/axios/axios'
import { lsRemove } from '@/utils/localStorageController'

export const state = {
  isUserAuthorized: false
}

function checkIfUserIsAuthorizedById () {
  if (document.getElementById('HybrisSelfCareB2CComponentIsUserAuthorized')) {
    return document.getElementById('HybrisSelfCareB2CComponentIsUserAuthorized').value === 'True'
  }

  return false
}

function fetchUserToken () {
  mvcRequest.get('auth/token')
    .then(response => {
      saveUserToken(response.data.token)
      lsRemove('sc_menu_services')
      lsRemove('sc_tosConfirmed') // nije bas dobro da bude ovde TODO Refactor
    })
    .catch(e => {
      // handle errors here
      console.log('Error fetching user token')
    })
}

function fetchUserInfo () {
  return apiRequest.get('user/info')
    .then(({ data }) => data)
}

function setUserId (uuid) {
  return apiRequest.put(`user/uuid/${uuid}`)
}

export default {
  init () {
    state.isUserAuthorized = checkIfUserIsAuthorizedById()
    if (!customRouter.isPublicRoute() && state.isUserAuthorized) {
      if (!getUserToken()) {
        fetchUserToken()
      }
    } else {
      removeUserToken()
    }
  },
  fetchUserInfo,
  setUserId
}
